import React, { useState, useEffect } from "react";
import trampoline from "../../../assets/img/imagefile/imagefile/Ninja Park.png";
import playground from "../../../assets/img/product_img/Ninja Course.jpg";
import trampoline1 from "../../../assets/img/product_img/Ninja kids 2.jpg";
import interactiveGame from "../../../assets/img/product_img/interactiveGame.png";
import products from "../../../assets/img/imagefile/imagefile/product_img.png";
import { Link } from "react-router-dom";
import plusicon from "../../../assets/img/product_img/plusicon.png";
import WhatsappButton from "../../../components/WhatsappButton";

import Dashboard from "../../../components/Dashboard";
import Header from "../../../components/Header";
import Footer from "../../../components/Footer";
import Breadcrumb from "../../../Breadcrumb";
import { Helmet } from "react-helmet-async";
const NinjaPark = () => {
  let description = (
    <>
    <h2 style={{fontWeight: 400,fontSize: '17.5px',lineHeight: '26px',letterSpacing: '2%',}}>
      Your gateway to the ultimate entertainment experience!Explore
      <br />
      our cutting-edge products and immerse yourself in a world of
      <br />
      innovation and excitement.
      </h2>
    </>
  );
  

  return (
    <div>
      <Helmet>
        <meta
          name="kids playground"
          content="GEM is the highest quality trampoline, crafted for durability and 
performance. Trusted by playground equipment manufacturers for 
unmatched safety and fun"
        />
      </Helmet>
      <Header />
      <Dashboard
        Breadcrumb={
          <div
            style={{
              backgroundColor: "",
              marginTop: "13%",
              marginLeft: "2%",
              borderRadius: "5px",
              width: "100%",
            }}
          >
            <Breadcrumb />
          </div>
        }
        title={"Ninja Park"}
        imageUrl={trampoline}
        description={description}
      />
      <div>
        <WhatsappButton
          altText="Chat with us on WhatsApp"
          iconSize={70}
        />
        <Link
          to="/getquotations"
          style={{ textDecoration: "none", color: "inherit" }}
        >
          <div className="icon-container">
            <img
              src={plusicon}
              alt="trampoline park with soft play"
              className="Producticon"
              style={{ cursor: "pointer" }}
            />
            <button className="quotation-button">Get Quotation</button>
          </div>
        </Link>
      </div>

      <div className="product-container">
        <div className="product-row">
          <div className="product">
            <Link
              to="/NinjaPark/NinjaKids"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={trampoline1}
                alt="/playground equipment suppliers"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Ninja Kids </p>
            </Link>
          </div>
          <div className="product">
            <Link
              to="/NinjaPark/NinjaCourse"
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <img
                src={playground}
                alt="playground equipment catalog"
                className="product-image"
                style={{ cursor: "pointer" }}
              />
              <p>Ninja Course</p>
            </Link>
          </div>
        </div>
      </div>
      {/* Include Footer component */}
      <Footer />
    </div>
  );
};
export default NinjaPark;
